import React from 'react';

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33341 9.14588L12.5208 13.334L13.334 12.5221L9.1454 8.33398L13.334 4.14703L12.522 3.33398L8.33341 7.52209L4.14597 3.33398L3.33398 4.14703L7.52142 8.33398L3.33398 12.5209L4.14597 13.334L8.33341 9.14588Z"
      fill="#153142"
    />
  </svg>
);
